import React from 'react';
import { ArrowRight, Sparkles } from 'lucide-react';
import { Badge, Button } from './ui';
import { scrollToPurchaseSection } from '../utils';
// Único asset del mockup oficial de Meal Prep Fitness usado en toda la landing.
export const HERO_MOCKUP_SRC = 'https://cdn.magicpatterns.com/uploads/djBkMUUdrkQy1nJWwLwNCs/mp.png';
type HeroProps = {
  onPurchaseRequest?: () => void;
};
export function Hero({
  onPurchaseRequest
}: HeroProps) {
  const handlePurchaseClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    // La sección de compra se monta de forma diferida: si todavía no existe,
    // se delega en App para montarla y desplazarse en cuanto esté disponible.
    if (!scrollToPurchaseSection()) {
      onPurchaseRequest?.();
    }
  };
  return <section className="relative pt-4 pb-16 md:pt-6 md:pb-24 px-4 overflow-hidden pl-[16px] pr-[16px]" data-id="element-14" data-mp="3d1aa1ojbgjfe">
      {/* Background glow */}
      <div className="hero-backdrop absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-brand-200/40 rounded-full blur-[120px] pointer-events-none" data-id="element-15" data-mp="381nv9anuav4h"></div>

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-16" data-mp="3o7vhbcfrj9tl">
        <div className="inline-flex items-center gap-2 mb-4" data-id="element-17" data-mp="39acuwgqk58pb">
          <Sparkles className="w-6 h-6 text-brand-500" aria-hidden="true" data-id="element-18" data-mp="39a36gxl5v9lq" />
          <span className="text-brand-600 font-bold tracking-widest uppercase text-sm md:text-base" data-id="element-19" data-mp="3e84odf6up2vm">
            🥗 PUNTO DIGITAL™
          </span>
        </div>

        <h1 className="md:text-[52px] font-black text-ink mb-4 tracking-tight text-[23px]" data-id="element-20" data-mp="358hmksa7lv21">
          ¿SIN TIEMPO PARA COCINAR Y MANTENER TU ALIMENTACIÓN?
        </h1>

        <div className="relative mt-4 mb-6 flex justify-center" data-id="element-21" data-mp="2qhqurk8mavyx">
          <div className="hero-mockup-glow absolute inset-0 bg-lav-200/50 blur-[80px] rounded-full pointer-events-none" data-id="element-22" data-mp="2vjpyiv89ruwe"></div>
          <img key={HERO_MOCKUP_SRC} src={HERO_MOCKUP_SRC} alt="Megapack Meal Prep Fitness Listo, con seis tomos y cinco bonos incluidos" className="relative z-10 mx-auto block w-[420px] h-[420px] max-w-full object-contain" width={420} height={420} style={{
          aspectRatio: '1 / 1',
          objectFit: 'contain',
          objectPosition: 'center center',
          backgroundColor: 'transparent',
          backgroundSize: 'contain',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center center'
        }} loading="eager" fetchPriority="high" decoding="async" data-id="element-23" data-mp="2hjymv1586qlk" />
        </div>

        <p className="text-slate-400 max-w-2xl mx-auto text-[14px] mt-[3px] mb-[3px]" data-id="element-24" data-mp="111esj6pp56lr">
          Organizá toda tu semana de comidas fitness en pocas horas, mantené tu
          alimentación sin improvisar y dejá de perder tiempo cocinando todos
          los días.
        </p>

        <div className="flex flex-nowrap justify-center gap-2 mb-8 overflow-x-auto" data-id="element-25" data-mp="3hr3sjxze2f6v">
          <Badge className="whitespace-nowrap" data-id="element-26" data-mp="1x9krqeihcqdi">✅ 100% PDF</Badge>
          <Badge className="whitespace-nowrap" data-id="element-27" data-mp="1x785hp5ovtun">⚡ Acceso inmediato</Badge>
          <Badge className="whitespace-nowrap" data-id="element-28" data-mp="21bpjt8ta5ey1">🥗 6 Tomos + 5 Bonos</Badge>
        </div>

        <div className="flex flex-col items-center gap-6" data-id="element-29" data-mp="268y3xexznt1x">
          <Button type="button" size="md" className="w-full md:w-auto group" onClick={handlePurchaseClick} data-id="element-30" data-mp="2b0fvjce4gha8">
            <span className="group-hover:scale-110 transition-transform" data-id="element-31" data-mp="2fziymrajkdfk">
              🥗 QUIERO MI MEAL PREP FITNESS
            </span>
            <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-32" data-mp="2p0qqormgsi17" />
          </Button>

          <div className="flex flex-wrap justify-center items-center gap-6 text-sm text-slate-400" data-id="element-33" data-mp="2tztuy9umek84">
            <span className="flex items-center" data-id="element-34" data-mp="un95vcdg1z9v">🛡️ Garantía 7 días</span>
            <span className="flex items-center" data-id="element-35" data-mp="zlaqw2ufk8nz">🔒 Pago seguro</span>
            <span className="flex items-center" data-id="element-36" data-mp="znn6wagmo8ye">💳 Mercado Pago</span>
          </div>
        </div>
      </div>
    </section>;
}